import { render, staticRenderFns } from "./ProductAddEdit.vue?vue&type=template&id=b7c5eb02&scoped=true&"
import script from "./ProductAddEdit.vue?vue&type=script&lang=js&"
export * from "./ProductAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddEdit.vue?vue&type=style&index=0&id=b7c5eb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c5eb02",
  null
  
)

export default component.exports